const resultFunction = (visibleAnnouncements) =>
  visibleAnnouncements
    .filter((announcement) => announcement.walletBanner)
    .sort((a, b) => {
      if (a.isPrioritized && !b.isPrioritized) return -1
      if (!a.isPrioritized && b.isPrioritized) return 1
    })

const walletBannersSelectors = {
  id: 'walletBanners',
  resultFunction,
  dependencies: [
    //
    { selector: 'visibleAnnouncements' },
  ],
}

export default walletBannersSelectors
